import React, { useState } from "react";
import "./Tabs.scss";

const Tabs = ({
  tabs = [],
  orientation = "horizontal", // "horizontal" or "vertical"
  onTabChange = () => {},
  defaultActiveId = null,
}) => {
  const [activeTab, setActiveTab] = useState(
    defaultActiveId || (tabs.length > 0 ? tabs[0].id : null)
  );

  const handleClick = (tab) => {
    if (tab.disabled) return; // disable click
    setActiveTab(tab.id);
    onTabChange(tab);
  };

  return (
    <div className={`tabs-container ${orientation}`}>
      <ul className="tabs-list">
        {tabs.map((tab) => (
          <li
            key={tab.id}
            className={`tab-item ${
              activeTab === tab.id ? "active" : ""
            } ${tab.disabled ? "disabled" : ""}`}
            title={tab.label}
            onClick={() => handleClick(tab)}
          >
            {tab.label}
          </li>
        ))}
      </ul>

      <div className="tabs-content">
        {tabs.map(
          (tab) =>
            tab.id === activeTab && (
              <div key={tab.id} className="tab-panel">
                {tab.content}
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default Tabs;
